var rtl_default = {
  "rtl": "I1yQ-",
  "ltr": "HpGU9"
};
export {
  rtl_default as default
};
//# sourceMappingURL=rtl-scss.js.map
